import React from 'react';

// Function to deep clone an object
export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') {
    return obj; // Return primitives as is
  }

  if (React.isValidElement(obj)) {
    return obj; // Return JSX/HTML content as is
  }

  if (Array.isArray(obj)) {
    return obj.map(deepClone); // Recursively clone arrays
  }

  const clonedObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepClone(obj[key]); // Recursively clone properties
    }
  }
  return clonedObj;
};
